/*
 * @Author: Teemo Ding
 * @Date: 2022-05-11 16:57:28
 * @LastEditTime: 2022-05-11 17:24:17
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Permissions/Components/RemoveUserModal/index.tsx
 */
import { ModalFooter } from '@/src/components/Antd';
import PasswordInput from '@/src/components/Password';
import { removeUser } from '@/src/request/settings/permission';
import { useRequest } from 'ahooks';
import { Form, message } from 'antd';
import React, { Fragment } from 'react';
import { useHistory, useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { getStoreUuid } from 'src/tools/getUserInfo';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from './css.module.less';

interface IParams {
  userUuid: string;
}
const RemoveUserModal = ({ onCancel, name, email, mobile }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  const history = useHistory();
  const { userUuid } = useParams<IParams>();
  const storeUuid = getStoreUuid();

  const { run: _removeUser, loading } = useRequest(
    (password) => removeUser({ userUuid, password, storeUuid }),
    {
      manual: true,
      onSuccess: () => {
        message.success(getI18n('general.deletedsuccessfully'));
        history.push('/settings/permissionsList');
      },
    },
  );
  const onFinish = (values) => {
    _removeUser(values.password);
  };
  return (
    <Fragment>
      <Form
        className={css.removeUserModal}
        form={form}
        onFinish={onFinish}
        name='transferOwnershipModal'>
        <div className={css.p}>
          {replaceI18nVariables(
            getI18n('usersAndPermissions.detail.passwordTip'),
            name || email || mobile || '',
          )}
        </div>
        <Form.Item
          name='password'
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('usersAndPermissions.detail.password'),
              ),
            },
          ]}
          label={getI18n('usersAndPermissions.detail.password')}
          labelCol={{ span: 24 }}>
          <PasswordInput editable={true} />
        </Form.Item>
      </Form>
      <ModalFooter
        danger
        okText={getI18n('general.remove')}
        onOk={() => form.submit()}
        onCancel={onCancel}
        loading={loading}
      />
    </Fragment>
  );
};

export default RemoveUserModal;
